import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Section, TwoColumns } from '../../Section';
import { SectionTitle } from '../../Typography';
import OpportunityItem from './OpportunityItem';
import { Paragraph, StyledLinkA } from '../../Typography/index';
import { mediaQueries } from '../../../style/breakpoints';
import sizes from 'src/style/sizes';
import colors from 'src/style/colors';

const Opportunities = React.memo(() => {
  return (
    <Section theme="light">
      <TwoColumns
        sizeLeft={sizes.columnWidth.small}
        left={
          <div
            css={{
              [mediaQueries.tabletLandscapeUp]: {
                paddingRight: 20,
              },
            }}
          >
            <SectionTitle>Quels débouchés après un bootcamp&nbsp;?</SectionTitle>
            <Paragraph>
              Se former au métier de Concepteur Développeur d'Applications vous permettra de vous
              orienter vers différents « métiers en tension », c'est à dire des métiers sur lesquels
              les entreprises ont beaucoup de mal à recruter.
            </Paragraph>
            <StaticImage
              src="../../../../src/data/images/2023_students7.jpg"
              alt="Etudiants au Réacteur"
              // placeholder="none"
              css={{
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                borderRadius: 5,
                boxShadow: '5px 25px 40px rgba(0, 0, 0, 0.2)',
              }}
            />
          </div>
        }
        sizeRight={sizes.columnWidth.large}
        right={
          <div
            css={{
              [mediaQueries.tabletLandscapeUp]: {
                paddingLeft: 24,
              },
            }}
          >
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'space-between',
                [mediaQueries.tabletPortraitUp]: {
                  flexDirection: 'row',
                },
                [mediaQueries.tabletLandscapeUp]: {
                  flexDirection: 'row',
                  paddingTop: 10,
                },
              }}
            >
              <OpportunityItem
                title="Postes à pourvoir et salaires moyens constatés"
                item={[
                  {
                    name: "Junior (0 à 2 ans d'exp.)",

                    link: 'https://www.indeed.fr/jobs?q=d%C3%A9veloppeur+full+stack+react&l=Paris+%2875%29',

                    salary: {
                      paris: { type: 'Paris', value: '35 - 45K' },
                      metropoles: { type: 'Grandes villes', value: '30 - 45K' },
                      regions: { type: 'Régions', value: '28 - 35K' },
                    },
                  },
                  {
                    name: "Confirmé (2 à 5 ans d'exp.)",
                    link: 'https://www.indeed.fr/emplois?q=d%C3%A9veloppeur+front+end+react&l=Paris+%2875%29',
                    salary: {
                      paris: { type: 'Paris', value: '48 - 65K' },
                      metropoles: { type: 'Grandes villes', value: '40 - 50K' },
                      regions: { type: 'Régions', value: '35 - 48K' },
                    },
                  },
                  {
                    name: "Senior (Plus de 5 ans d'exp.)",
                    link: 'https://www.indeed.fr/emplois?q=d%C3%A9veloppeur+front+end+react&l=Paris+%2875%29',
                    salary: {
                      paris: { type: 'Paris', value: '60 - 70K' },
                      metropoles: { type: 'Grandes villes', value: '50 - 65K' },
                      regions: { type: 'Régions', value: '45 - 60K' },
                    },
                  },
                ]}
              />

              <div
                css={{
                  [mediaQueries.phoneOnly]: {
                    height: 15,
                  },
                  [mediaQueries.tabletPortraitUp]: {
                    height: 40,
                  },
                }}
              />
            </div>
            <Paragraph css={{ fontSize: 15, marginTop: 10 }}>
              {/* Source :{' '}
              <StyledLinkA
                css={{ fontSize: 15, color: colors.purple }}
                rel="noopener noreferrer nofollow"
                target="_blank"
                href="https://www.silkhom.com/salaire-informatique-electronique-2022/"
              >
                silkhom.com
              </StyledLinkA>
              .
              <br /> */}
              Retrouvez des centaines d'offres d'emploi sur{' '}
              <StyledLinkA
                css={{ fontSize: 15, color: colors.purple }}
                rel="noopener noreferrer nofollow"
                target="_blank"
                href="https://www.welcometothejungle.com/fr/jobs?query=react"
              >
                Welcome to the Jungle
              </StyledLinkA>
              ,{' '}
              <StyledLinkA
                css={{ fontSize: 15, color: colors.purple }}
                rel="noopener noreferrer nofollow"
                target="_blank"
                href="https://jobs.stationf.co/search?departments%5B0%5D=Tech"
              >
                StationF
              </StyledLinkA>
              ,{' '}
              <StyledLinkA
                css={{ fontSize: 15, color: colors.purple }}
                rel="noopener noreferrer nofollow"
                target="_blank"
                href="https://fr.indeed.com/jobs?q=react&l=%C3%8Ele-de-France"
              >
                indeed
              </StyledLinkA>
              ,{' '}
              <StyledLinkA
                css={{ fontSize: 15, color: colors.purple }}
                rel="noopener noreferrer nofollow"
                target="_blank"
                href="https://www.linkedin.com/jobs/search/?keywords=React.js&refresh=true"
              >
                LinkedIn
              </StyledLinkA>
              , etc.
            </Paragraph>
          </div>
        }
      />
    </Section>
  );
});
export default Opportunities;
